import React, { useState, Fragment } from "react";
import groupBy from "lodash/groupBy";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { INTERVAL_ORDER } from "utils/constants/payment";
import { STATE_KEYS } from "utils/constants/state";
import { getEnvCollection } from "components/FormerEditor/common";
import Callout from "components/Callout";
import Toggle from "react-toggle";
import IntervalPrices from "./IntervalPrices";
import { getToggleProps } from "utils/form";
import { getPrimaryForProductIntervalCurrency } from "utils/pricing";
import PricesCurrencySelect from "components/PricesCurrencySelect";

const PrimaryPriceIntervalPicker = ({ name }) => {
  const { values } = useFormikContext();
  const [showInactive, setShowInactive] = useState(false);
  const defaultCurrency = get(
    values,
    STATE_KEYS.MANIFEST.PRICING_DEFAULT_CURRENCY
  );
  const [activeCurrency, setActiveCurrency] = useState(defaultCurrency);

  const { prices, products } = useSelector((state) => {
    return {
      prices: getEnvCollection(state.getIn(["price", "data"]).toJS()),
      products: getEnvCollection(state.getIn(["product", "data"]).toJS())
    };
  });

  const productBlock = get(values, name);
  const matchingProduct = products.find(({ id }) => id === productBlock.uid);

  if (matchingProduct) {
    const productPrices = prices.filter((price) => {
      const isProductMatch =
        price.product === matchingProduct.id &&
        price.currency === activeCurrency;
      if (showInactive) {
        return isProductMatch;
      } else {
        return isProductMatch && price.active;
      }
    });
    const hasInactive = prices.find(({ active }) => !active);
    const priceGroups = groupBy(productPrices, STATE_KEYS.PRICE.INTERVAL);
    const primaries = get(values, STATE_KEYS.MANIFEST.PRICING_PRIMARIES);

    return (
      <Fragment>
        <PricesCurrencySelect
          prices={prices}
          value={activeCurrency}
          setActiveCurrency={setActiveCurrency}
        />
        {hasInactive && (
          <div className="pt3 flex flex-row justify-between items-center">
            <label className="f6 fw5 db">Show inactive prices</label>
            <Toggle
              {...getToggleProps({
                active: showInactive,
                setFieldValue: (_, active) => setShowInactive(active)
              })}
            />
          </div>
        )}
        <div className="pt3">
          {INTERVAL_ORDER.map((interval, intervalIx) => (
            <IntervalPrices
              key={intervalIx}
              isFirst={!intervalIx}
              isLast={INTERVAL_ORDER.length - 1 === intervalIx}
              interval={interval}
              primary={getPrimaryForProductIntervalCurrency({
                primaries,
                interval,
                currency: activeCurrency,
                product: matchingProduct.id
              })}
              prices={priceGroups[interval]}
            />
          ))}
        </div>
      </Fragment>
    );
  } else {
    return (
      <div className="pt2">
        <Callout
          copy={`No product price data.`}
          customClasses={{
            container:
              "flex ph2 ba br2 items-center b--black-10 pv2 w-100 justify-between"
          }}
        ></Callout>
      </div>
    );
  }
};

export default PrimaryPriceIntervalPicker;
